import { useCallback, useEffect } from 'react';

// local imports
import { CommonService } from 'app/services';
import useDataApi from '../../use-data-api';
import { Mapper } from 'app/utils';

const usePharmacySupportSubjectsService = () => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    // pharmacy support subjects
    const supportSubjects = await CommonService.getPharmacySupportSubjects();
    const supportSubjectsData = supportSubjects?.data?.data;

    const out = supportSubjectsData?.map(item => {
      const { id } = item;
      return {
        value: id,
        label: Mapper.customerSupportSubjects(id)
      };
    });

    return { subjects: out };
  }, []);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    _service: service,
    handleRefresh
  };
};

export default usePharmacySupportSubjectsService;
